import templateUrl from './editor-template.html';

export const editorTemplateComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        menuName: '@',
        parentSlug: '@'
    },

    templateUrl,

    controller: class EditorTemplateComponent {
        constructor($state, toastr, CompareObjectService, ModalService, EditorTemplateService, DashboardService) {
            'ngInject';

            this.$state = $state;
            this.toastr = toastr;
            this.compareObjectService = CompareObjectService;
            this.modalService = ModalService;
            this.editorTemplateService = EditorTemplateService;
            this.dashboardService = DashboardService;
        }

        $onInit() {
            this.activeMenuName = this.dashboardService.getActiveMenuName();

            this.details = this.editorTemplateService.getEditorContentDetailsObject(this.details, this.menuName);
            this.details.pageTitle = `Edit ${this.activeMenuName}`;
            
            this.savedData = angular.copy(this.details.menuContentDetails);
        }

        onCancel() {
            const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, false);

            if (isUpdated) {
                this.modalService.open({
                    details: {
                        bodyMessage: 'Changes done will be reverted. Continue?'
                    },
                    buttons: [{
                        name: 'No'
                    }, {
                        name: 'Yes',
                        isPrimary: true,
                        action: _onSubmit.bind(this)
                    }]
                });

                function _onSubmit() {
                    this._redirectToParentState(this.parentSlug);
                }
            } else {
                this._redirectToParentState(this.parentSlug);
            }
        }

        onSubmit() {
            this.disableButtons = true;
            const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details.menuContentDetails, true);

            if (isUpdated) {
                this.editorTemplateService.updatetEditorDetails(this.details.menuContentDetails, this.menuName)
                    .then((details) => {
                        this.toastr.success('data updated successfully');
                        this._redirectToParentState(this.parentSlug);
                    }).catch((err) => {
                        this.toastr.error(err);
                        this.disableButtons = false
                    });
            }
            else {
                this.toastr.success('Nothing to update');
                this._redirectToParentState(this.parentSlug);
            }
        }

//*********************************************************Private Methods ***************************************** */

        _redirectToParentState(slug) {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: slug
			});
		}
    }
}


// WEBPACK FOOTER //
// ./src/app/components/editor-template/editor-template.component.js